import React, { useState } from 'react';
import FilledButton from './ui/FilledButton';
import { NavLink } from 'react-router-dom';
import Status from './ui/Status';

const SubmissionsTable = ({ submissions, onView, onUpdateStatus }) => {
    const [isLoading, setIsLoading] = useState(false);
    const statusList = {
        submitted: 'blue',
        evaluated: 'sky',
        completed: 'green',
        rejected: 'red'
    };

    const handleStatusUpdate = async (submitId, status) => {
        setIsLoading(true); 
        const res = await onUpdateStatus(submitId, status); 
        setIsLoading(false); 
    }

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full border shadow">
                <thead className="bg-blue-50 text-center text-blue-700">
                    <tr>
                        <th className="px-6 py-3">Submit ID</th>
                        <th className="px-6 py-3">Submitted At</th>
                        <th className="px-6 py-3">User ID</th>
                        <th className="px-6 py-3">Challenge ID</th>
                        <th className="px-6 py-3">Reel URL</th>
                        <th className="px-6 py-3">Thumbnail URL</th>
                        <th className="px-6 py-3">Views</th>
                        {/* <th className="px-6 py-3">Description</th> */}
                        {/* <th className="px-6 py-3">Status</th> */}
                        {/* <th className="px-6 py-3">Actions</th> */}
                    </tr>
                </thead>
                <tbody>
                    {submissions?.map((submission) => (
                        <tr key={submission.submit_id} className="border-b text-center font-semibold text-sm text-slate-700">
                            <td className="px-6 py-3">{submission.submit_id}</td>
                            <td className="px-6 py-3">{new Date(submission.submitted_at).toLocaleString()}</td>
                            <td className="px-6 py-3">{submission.user_id}</td>
                            <td className="px-6 py-3">{submission.challenge_id}</td>
                            <td className="px-6 py-3"><a href={submission.reel_url} target="_blank" rel="noopener noreferrer">view</a></td>
                            <td className="px-6 py-3"><a href={submission.thumbnail_url} target="_blank" rel="noopener noreferrer">view</a></td>
                            <td className="px-6 py-3">{submission.views}</td>
                            {/* <td className="px-6 py-3">
                                <NavLink to={'/submissions/play/' + submission.reel_url} className={'text-blue-500 underline'} >View Reel</NavLink>
                            </td> */}
                            {/* <td className="px-6 py-3">{submission.description}</td> */}
                            {/* <td className="px-6 py-3">
                                <Status label={submission.status} color={statusList[submission.status]} />
                            </td> */}
                            {/* <td className="px-6 py-3">
                                <FilledButton label={isLoading ? 'Updating' : 'update'} disabled={isLoading || (submission.status === 'completed')} onClick={() => handleStatusUpdate(submission.submit_id, submission.status)} />
                            </td> */}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SubmissionsTable;